export default "/assets/website/images/simple-pay.svg?12fd615f103367058a154a72389f0875";